import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { Stockitem } from '../../../../interfaces/stockitem';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dailyproducts',
  templateUrl: './dailyproducts.component.html',
  styleUrl: './dailyproducts.component.scss'
})



export class DailyproductsComponent implements OnInit {
  isFullPage = false;
  contentReady = true;
  allData: Stockitem[] = [];
  noData = false;

  totalItems = 0;
  stockTotal: any;
  page = 1;

  isAr = false;
  isMobile = false;
  itemCount = 9;

  private isBrowser: boolean;

  constructor(
    private deviceService: DeviceDetectorService,
    private _advancedStocks: AdvancedStocksService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    // ⛔ SSR يقف هنا
    if (!this.isBrowser) {
      return;
    }
    if (currentUrl.includes('dailyoffers')) {
      this.isFullPage = true;
    }
    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.itemCount = this.isMobile ? 8 : 9;
    this.isAr = localStorage.getItem('language') === 'ar';

    this.getDailyOffers();
  }

  // ================= DATA =================
  getDailyOffers(): void {
    this.contentReady = true;
    this.page = 1;

    this._advancedStocks
      .getDailyOffers(1, this.page)
      .subscribe({
        next: (data: any) => {

          this.allData = data.data;
          this.stockTotal = data.total;
          this.totalItems = data.last_page;

          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.noData = true;
          this.contentReady = false;
        },
      });
  }


  // ================= INFINITE SCROLL =================
  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    if (!this.isBrowser || this.contentReady) return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached =
      scrollPosition + windowHeight >= pageHeight - 10;

    if (this.page === 1) {
      this.page = 2;
    }

    // عندك حد أقصى 5 صفحات حسب الكود الأصلي
    if (bottomReached && this.page <= 5) {
      this.loadMore();
    }
  }

  private loadMore(): void {
    this.contentReady = true;

    this._advancedStocks
      .getDailyOffers(1, this.page)
      .subscribe({
        next: (data: any) => {
          this.allData = [...this.allData, ...data.data];
          this.page++;

          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        },
      });
  }


}
